import './App.css';
import {Formulario} from './componentes/Formulario'
import {FormularioContextProvider} from './contextos/FormularioContext'
import theme from './themeConfig'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useState } from 'react';
import {FueraDeServicio} from './componentes/FueraDeServicio'
import {Opciones} from './componentes/Opciones'
import {Constancia} from './componentes/Constancia'
import {Colaborador} from './componentes/Colaborador'
import {Eventos} from './componentes/Eventos'
import { Default } from './componentes/Default';
import {ETEvento} from './componentes/ETEvento'
import {ETEventos} from './componentes/ETEventos'
import {ETInscripcionItem} from './componentes/ETInscripcionItem'
import { ThemeProvider, CssBaseline } from '@mui/material';



function App() {

  return <ThemeProvider theme={theme}>
      <CssBaseline />
          <Router>
      <div className="App" stylxe={{height:'100%',backgroundRepeat:'no-repeat',backgroundSize:'cover',
      background:'rgb(26, 36, 67)',
     }}>
        <div>
          {/* {<Logo/>} */}
            <FormularioContextProvider>
                {/*<FueraDeServicio/>*/}
               <RutasNuevas/>
              {/*<MesaDeAyuda/>*/}
            </FormularioContextProvider>
        </div>
      </div>
    </Router>

    </ThemeProvider>
}

const RutasNuevas = ()=>{
  return <Routes>
            <Route default path='*' element={<Default/>} />  
            {/* <Route default path='/' element={<Eventos/>} /> */}
            {/* <Route path='/newversion' element={<ETEventos/>} /> */}
            <Route default path='/' element={<ETEventos/>} />
            <Route path='/colaborador/:id/:id_evento' element={<Colaborador/>} />  
            <Route path='/admin/temporal/:id/:id_evento' element={<Colaborador noValidarUsuario={true}/>} />  
            <Route path='/evento/:id_evento/:target' element={<ETEvento/>} />   
            <Route path='/inscripcion/item/:id_evento/:id_evento_valor' element={<ETInscripcionItem texto="Sitio en mantenimiento"/>} />   
            <Route path='/ministros/validate/:tokenmin' element={<ETEventos/>} />   
            <Route path='/temporalMODIFICARESTOBORRARTODOENMAYUSCULA/testing/:token/' element={<Eventos/>} />  
    </Routes>
}

const RutasLegacy = ()=>{
  return <Routes>
            <Route default path='*' element={<Default/>} />  
            {/* <Route default path='/' element={<Default texto="Sitio en mantenimiento"/>} />    */}
            {/* <Route default path='/' element={<Formulario tipo="general"/>} />    */}
            <Route default path='/' element={<Eventos/>} />
            {/* <Route path='/contingentes/inscripcion/:nro_cupon' element={<Formulario tipo="contingente"/>} />  
            <Route path='/cupones/inscripcion/constancia/:id_alta_web' element={<Constancia tipo="contingente"/>} />  
            <Route path='/contingentes/inscripcion/' element={<Formulario tipo="contingente"/>} />   */}
            <Route path='/colaborador/:id/:id_evento' element={<Colaborador/>} />  
            <Route path='/admin/temporal/:id/:id_evento' element={<Colaborador noValidarUsuario={true}/>} />  
            {/* <Route path='/preferencia' element={<Opciones tipoInscripcion="preferencia"/>} />   */}
            {/* <Route path='/eventos' element={<Eventos />} />  */}
            <Route path='/eventos' element={<Default texto="Sitio en mantenimiento"/>} />   
            {/* <Route path='/temporal' element={<Eventos/>} />    */}
            <Route path='/endesarrollo' element={<Eventos/>} />   
            <Route path='/ministros/validate/:tokenmin' element={<Eventos/>} />   
            {/* <Route path='/testing/:token/' element={<Eventos/>} />   */}
            <Route path='/temporalMODIFICARESTOBORRARTODOENMAYUSCULA/testing/:token/' element={<Eventos/>} />  
    </Routes>
}

export default App;




